import { ASSET_PATHS } from '../../utils/assetPath';

import './WordDocFileIcon.css';

interface WordDocFileIconProps {
  /**
   * Additional CSS class name
   */
  className?: string;
  /**
   * Icon size in pixels
   */
  size?: number;
  /**
   * Accessible label for the icon
   */
  ariaLabel?: string;
}

function WordDocFileIcon({ className = '', size = 32, ariaLabel = 'Word document' }: WordDocFileIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`word-doc-file-icon ${className}`}
      height={size}
      src={ASSET_PATHS.WORD_DOC_FILE_ICON}
      width={size}
    />
  );
}

export default WordDocFileIcon;
